module.exports = __webpack_public_path__ + "media/images/career_camp/2023/areas_3-8d9eddcf68ae6cb905d36f3f38c6f135.png";